<template>
   <div class="add-comment-modal">
      <ModalWrapper :open="open" @close="$emit('close')">
         <template #header>
            <h3>Leave a Comment</h3>
         </template>
         <template #body>
            <textarea
               type="text"
               rows="3"
               placeholder="Enter your comment"
               v-model="comment"
            />
         </template>
         <template #footer>
            <Btn
               class="button save-button blue"
               text="Save"
               @click="onSaveComment"
               :disabled="!comment.length"
            ></Btn>
         </template>
      </ModalWrapper>
   </div>
</template>

<script setup lang="ts">
const { review } = useTeachable();
const emit = defineEmits(["saveComment", "close"]);
const props = defineProps({
   open: { type: Boolean, required: true },
});
const comment = ref(review?.value?.review || "");
const onSaveComment = () => {
   emit("saveComment", comment.value);
};

watchPostEffect(() => {
   if (props.open) {
      comment.value = review?.value?.review || "";
   }
});
</script>

<style lang="scss">
// FIXME: This should not be here. Modal should follow the modal.scss styles
.modal-body {
   padding: pad(2) 0 pad(4);
   textarea {
      width: 100%;
      border-radius: 4px;
      border: 1px solid $border;
      padding: pad(1);
      resize: none;
      &:focus {
         border-color: $blue;
      }
   }
}
.modal-footer {
   @include flex(column, flex-end, flex-start);
}
</style>
